export const iconFontAwesomeEnergyPlugCircleExclamation = (
	<i className="fa-solid fa-plug-circle-exclamation"></i>
);
